import { environment } from '@environments/environment';

// This file is used to decalre all the static constants in whole project.
export const Messages = {
  jobCreatedSuccess: 'Job is created sucessfully',
  jobCreatedError: 'Job not created',

  jobCommentSuccess: 'Job comment updated sucessfully',
  jobCommentError: 'Comment not updated',

  jobDescriptionSuccess: 'JD created sucessfully',
  jobDescriptionSuccessEdit: 'JD edited sucessfully',
  jobDescriptionError: 'JD not created',

  recruiterAssignedSuccess: 'Recruiter assigned sucessfully',
  recruiterAssignedError: 'Recruiter not assigned',

  jobEditedSuccess: 'Job edited sucessfully',
  jobEditedError: 'Job edited failed',

  applicantCreatedSuccess: 'Applicant created sucessfully',
  applicantCreatedError: 'Applicant Creation failed',
  applicantEdited: 'Applicant edited successfully',

  technologyCreatedSuccess: 'Technology created sucessfully',
  technologyCreatedError: 'Technology Creation failed',
  technologyEdited: 'Technology edited successfully',
  technologyEditedError:  'Technology cannot be edited',
 

  sourceCreatedSuccess: 'Source created sucessfully',
  sourceCreatedError: 'Source Creation failed',
  sourceEdited: 'Source edited successfully',
  sourceEditedError:  'Source cannot be edited',

  alreadyRegisteredApplicant :'Applicant with same email or mobile number is already registered',

  feedbackSucess :'Feedback updated sucessfully',
  feedbackError :'Feedback error',
 
  fileUploadError: 'Please upload a valid file',

  tryAgain: 'Please try again.',
  invalidUser: 'Invalid username or password.',
  
  cancelInterview :'Interview cancelled',

  interviewScheduled:'Interview scheduled',
  interviewReScheduled:'Interview re-scheduled',
  alreadyInProcessMsg:'Selected candidate is already in process for this job posting, please click on ',
  forNextActionTxt:' for next action.',
   nextRoundScheduled:'Next round scheduled',
   Re_Scheduled:'Re-Scheduled',
   Scheduled:'Scheduled',
   Cancelled:'Cancelled',
   draft_candidate_evaluation_feedback:"Feedback draft successfully",
   sumbit_candidate_evaluation_feedback:"Feedback submitted successfully",
   sumbit_template:"Template created successfully",
   edit_template:"Template Modified successfully.",
   endpoint:{
    applicant : 'applicant',
    getAllApplicant : 'applicant/applicant-data',
    applicantJob : 'applicant/job',
    editSource : 'source/edit-source',
    addSource : 'source/add-source',
    editTechnology : 'technology/edit-technology',
    addTechnology : 'technology/add-technology',
    applicantDocument_applicant : 'applicant-document/applicant',
    applicantDocument :'applicant-document',
    fileUrlDomain:environment.apiUrl+'/download-file/',
    interview_interviewStepMapping :'interview/interview-step-mapping/',
    cancelInterview :'interview/cancel-interview',
    interview_job:'interview/job',
    interview :'/interview',
    interviewStatus:'interview-status',
    jobDescription_Search:'job-description/search/',
    jobDescription:'job-description',
    Recruiter:'user/role/Interviewer',
    RecruiterList: 'user/role/Recruiter',
    InterviewStep:'interview-step-status',
    applicant_Search:'applicant/search/',
    cvSubmit_search:'cvsubmit/fetchCvSubmit',
    Interview_updateInterviewStep:'interview/update-interview-step',
    filteredInterviewStepStatus:'interview-step-status/filtered-interview-step-status/',
    sourceNameParams :'&user_page=0&user_size=500&user_sort=firstName,ASC&page_page=0&page_size=500&page_sort=sourceName,ASC',
    candidate_evaluation_feedback:'/interview/candidate-evaluation-feedback/',
    interview_allinterviewStepMapping :'interview/all-interview-step-mapping/',
   },
   interviewStatusIds:{
    scheduled:'1',
    didnt_join:'2',
    waiting_for_schedule:'3',
    waiting_for_offer:'4',
    offered:'5',
    onHold:'6',
    futureConsideration:'7',
    closed_No_show:'8',
    closed_Rejected:'9',
    joined:'10',
    didnt_offered:'11',
   },
   interviewStepStatusIds:{
    Scheduled:'1',
    Re_Scheduled:'2',
    Rejected:'3',
    Cancelled:'4',
    On_hold:'5',
    Shortlisted:'6',
    Final_HR_round_done:'7',
   },
   employeeReferalId :'7df9c6c3-d336-4f55-a1b9-e13f9675a7ac',
};


